import { render, staticRenderFns } from "./IPsettings.vue?vue&type=template&id=6e71800d&scoped=true&"
import script from "./IPsettings.vue?vue&type=script&lang=js&"
export * from "./IPsettings.vue?vue&type=script&lang=js&"
import style0 from "./IPsettings.vue?vue&type=style&index=0&id=6e71800d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71800d",
  null
  
)

export default component.exports